import { Link, navigate } from "gatsby";
import React, { useContext, useEffect, useState } from "react";

// Components //
import Button from "../../atoms/button/button";

// Styles //
import "./iconCard.scss";

// Utils //
import { splitButtonText } from "../../../utils/helpers";
import GlobalContext from "../../../contexts/globalContext";
import { getCmdFormData, getToken } from "../../../services/formServices";

interface IconCardProps {
    title: string;
    description?: { json: any };
    imageUrl: string;
    textButton?: string;
    redirectButton: string;
}

const IconCard = ({
    title,
    description,
    imageUrl,
    textButton,
    redirectButton,
    }: IconCardProps) => {

        const [doRedirect, setDoRedirect] = useState(false);
        const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

        const Context = useContext(GlobalContext);
        
        const handleIngresaAction = async () => {
            if (Context.gigyaContext.gigyaAccount) {
                redirect();
            }
            else {
                Context.gigyaContext.loginComfamaId!();
                setDoRedirect(true);
            }
        }
        useEffect(() => {
            if (Context.gigyaContext.gigyaAccount && doRedirect) redirect();
        }, [Context.gigyaContext.gigyaAccount]);
        
        const redirect = async () => {
            setIsButtonDisabled(true);
            let responseData:any = await checkUserRegistered();
            if (responseData.data.answerData && responseData.data.answerData.documentId) {
                navigate(splitButtonText(redirectButton,0));
            }
            else{
                navigate(splitButtonText(redirectButton,1));
            }
            setIsButtonDisabled(false);
        }
    
        const checkUserRegistered = async () => {
            const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
            const response = await getCmdFormData(Context!.gigyaContext!.gigyaAccount!.data.docNumber, token);
            return response;
        }

    return (
        <div className="m-icon-card">
            <div className="m-icon-card__image">
                <img src={imageUrl} alt={title} />
            </div>
            <div className="m-icon-card__content">
                <div className="m-icon-card__content__text">
                    <h3>{title}</h3>
                    <>{description}</>
                </div>
                {textButton && (
                    <div className="m-icon-card__content__button">
                            <Button
                                onClickAction={handleIngresaAction}
                                type="button"
                                text={textButton}
                                classname={`a-button__magenta gtm_unete_a_la_comunidad_home_requisitos`}
                                isDisabled={isButtonDisabled}
                            />
                    </div>
                )}
            </div>
        </div>
    );
};

export default IconCard;
